import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { AccountPage } from '@/features/auth'
// Through `queries`, not the feature index: a loader is eager by construction.
import { authSettingsQuery, sessionsQuery } from '@/features/auth/queries'

import { sessionQuery } from '@/app/router/session'

export const Route = createFileRoute('/_auth/account')({
  // The session itself is already resolved by `_auth`. These two are not: the
  // password policy the form reads, and the session list under it, which is a
  // table and therefore cannot size its own pending state.
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(authSettingsQuery()),
      context.queryClient.ensureQueryData(sessionsQuery()),
    ])
  },
  component: AccountRoute,
})

function AccountRoute() {
  const { data: session } = useQuery(sessionQuery())

  return <AccountPage isPasswordChangeRequired={session?.mustChangePassword ?? false} />
}
